import React from "react";
import Gauge from "../basics/gauge/Gauge";
import {Placeholder} from "react-bootstrap";

export default function SkeletonGauge() {
    return (
        <div className="skeleton-gauge">
            <Gauge />
            <Placeholder className="w-25" />
        </div>
    );
}
